/**
 * @packageDocumentation
 * @module      AuditLogLine.ts
 * @description Models one line in an of audit log.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * One line in an audit log. Should mirror the like-named class on the server.
 */
export default class AuditLogLine {
    /**
     * Constructor.
     *
     * @param eventId The unique ID of the event.
     * @param eventTime The time of the maintenance event.
     * @param principalUsername The administrator who performed the maintenance event.
     * @param itemName The name of the item that was maintained. For example, the name of the system.
     * @param secondaryItemName The name of the other item in the transaction, such as an associated system.
     * @param summary A summary of the change.
     * @param success True if succeeded; false if not.
     */
    constructor(eventId, eventTime, principalUsername, itemName, secondaryItemName, summary, success) {
        this.eventId = eventId;
        this.eventTime = eventTime;
        this.principalUsername = principalUsername;
        this.itemName = itemName;
        this.secondaryItemName = secondaryItemName;
        this.summary = summary;
        this.success = success;
    }
    /**
     * Return an AuditLogLine built from a JSON object that might be returned from the server.
     *
     * @param json JSON representation of an audit log line.
     */
    static fromJSON(json) {
        return new AuditLogLine(json.eventId, new Date(Date.parse(json.eventTime)), json.principalUsername, json.itemName, json.secondaryItemName, json.summary, json.success);
    }
}
//# sourceMappingURL=AuditLogLine.js.map